import { useRef, useState } from "react"
import { api } from "../../../../services";
import { showError } from "../../../../services/notification";
import { useDebounceCallback } from "./useDebounceCallback";

export const useFindByAddress = (onChange, value) => {
  const [options, setOptions] = useState(null)
  const autocompleteRef = useRef(null);

  const handleError = () => {
    setOptions(null)
    showError("Greška pri dohvaćanju lokacija")
  }


  const findByAddress = async (value: string) => {
    if (!value) return;

    try {
      const response = await api.Location.fetchAutocompleteOptions(value,
        handleError
      )
      setOptions(response.map(item => JSON.stringify(item)))

    } catch (error) { }


  };

  const findByAddressDebounced = useDebounceCallback(findByAddress, 1000)

  const handleSelect = async (v) => {

    if (autocompleteRef.current) {
      autocompleteRef.current.blur();
    }


    const parsedValue = JSON.parse(v);

    try {
      const response = await api.Location.fetchPlaceDetails(parsedValue.placeId,
        handleError
      )
      onChange({
        ...value,
        latitude: response.latitude,
        longitude: response.longitude,
        countryId: response.countryId,
        countyId: response.countyId,
        cityId: response.cityId,
        settlementId: response.settlementId,
        isAutocompleteUsed: true,
      })

    } catch (error) { }


  }


  return {
    findByAddressDebounced,
    options,
    handleSelect,
    autocompleteRef,
  }
}


// WEBPACK FOOTER //
// ./src/containers/AdFormPage/LocationSelector/hooks/useFindByAddress.ts